import axios from "axios";
import { BACKEND_URL } from "../utils/api";

export interface Ambassador {
  id: string;
  ambassador: string;
  phone: string | null;
  email: string;
  level: string;
  promo_code: string;
  total_invites: number;
  lifetime_invites: number;
  total_active: number;
  volume_transactions: number;
  revenus_izi: number;
  bonus_parrain: number;
  bonus_filleul: number;
  bonus_cost: number;
  commission_pct: number;
  commission_amount: number;
  salary: number;
  gadgets: number;
  total_cost: number;
  profit_net: number;
  status: string;
  comment: string;
}

export interface AmbassadorUpdatePayload {
  commission_pct?: number;
  commission_amount?: number;
  salary?: number;
  gadgets?: number;
  status?: string;
  comment?: string;
}

export type AmbassadorPeriod = "" | "day" | "2weeks" | "month" | "quarter" | "semester" | "year";

export interface AmbassadorListParams {
  skip?: number;
  limit?: number;
  name?: string;
  email?: string;
  level?: string;
  promo_code?: string;
  status?: string;
  phone?: string;
  period?: AmbassadorPeriod;
  start_date?: string;
  end_date?: string;
}

export interface AmbassadorListResponse {
  items: Ambassador[];
  total: number;
  skip: number;
  limit: number;
  period?: {
    period: string | null;
    start_date: string | null;
    end_date: string | null;
  };
  summary: {
    total_ambassadors: number;
    total_filleuls: number;
    total_active_filleuls: number;
    total_revenus_izi: number;
    total_salary: number;
    total_cost: number;
    total_profit_net: number;
  };
}

export interface AmbassadorMonthlyStat {
  month: number;
  label: string;
  new_invites: number;
  new_active: number;
  volume_transactions: number;
  revenus_izi: number;
  referral_cost: number;
  other_cost: number;
  salary_paid: number;
  total_cost: number;
  profit_net: number;
}

export interface AmbassadorNetworkTotals {
  total_ambassadors: number;
  total_filleuls: number;
  total_active_filleuls: number;
}

export interface AmbassadorMonthlyStatsResponse {
  year: number;
  available_years: number[];
  totals: AmbassadorNetworkTotals;
  months: AmbassadorMonthlyStat[];
}

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return { Authorization: `Bearer ${token}` };
};

export const ambassadorService = {
  async listAmbassadors(params: AmbassadorListParams = {}) {
    const res = await axios.get(`${BACKEND_URL}/promo-code/ambassador-list`, {
      headers: getAuthHeaders(),
      params,
    });
    return res.data?.data as AmbassadorListResponse;
  },

  async getMonthlyStats(year: number) {
    const res = await axios.get(`${BACKEND_URL}/promo-code/ambassador-list/stats/monthly`, {
      headers: getAuthHeaders(),
      params: { year },
    });
    return res.data?.data as AmbassadorMonthlyStatsResponse;
  },

  async updateAmbassador(userId: string, payload: AmbassadorUpdatePayload) {
    const res = await axios.put(`${BACKEND_URL}/promo-code/ambassador-list/${userId}`, payload, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },
};
